var map = {
	"./cnn-money-x2.png": 2056,
	"./cnn-money.png": 2250,
	"./economist-x2.png": 2057,
	"./economist.png": 2251,
	"./mashable-x2.png": 2058,
	"./mashable.png": 2252,
	"./tech-crunch-x2.png": 2059,
	"./tech-crunch.png": 2253,
	"./thenewyorker-x2.png": 2060,
	"./thenewyorker.png": 2254,
	"./thrillist-x2.png": 2061,
	"./thrillist.png": 2255,
	"./time-x2.png": 2062,
	"./time.png": 2256,
	"./usa-today-x2.png": 2063,
	"./usa-today.png": 2257
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2249;